import * as R from 'ramda';
import reducer from './reducer';

export const root = R.path([reducer.name]);

export default {
  selectToasts: root,
};
